import { fontSize } from "@tphglobal/common/theme/style.typography";
import { greyScaleColour } from "@tphglobal/common/theme/style.palette";
import messages from "../messages";
import moment from "moment";

export const headerItems = [
  {
    key: "manage-locations",
    label: messages?.general?.headings?.manageLocations,
  },
  {
    key: "manage-users",
    label: messages?.general?.headings?.manageUsers,
  },
  {
    key: "about",
    label: messages?.general?.headings?.about,
  },
];

export const iconStyles = {
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  height: fontSize?.h4,
  width: fontSize?.h4,
};

export const ATTACHMENT_THREAT_RESPONSES = {
  THREATS_FOUND: "THREATS_FOUND",
  UNSUPPORTED: "UNSUPPORTED",
};

export const headerIconStyles = {
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  height: fontSize?.h2,
  width: fontSize?.h2,
  fill: greyScaleColour?.white100,
};

export const MAX_FILE_SIZE = 4;

export const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const downloadAppLink = {
  appStore: "https://apps.apple.com/us/app/tph-freelance-portal/id6670440468",
  playStore: "https://play.google.com/store/apps/details?id=com.freelancerapp",
};

export const EXTERNAL_LINKS = {
  termsOfUse: "https://tphglobal.com/legal/",
  privacyPolicy: "https://tphglobal.com/privacy-security/",
};

export const URL_CLEANUP_TIMEOUT_MS = 3000;

export const payFrequencyMap = Object.freeze({
  Weekly: () => 7,
  Fortnightly: () => 14,
  "4 weekly": () => 28,
  Monthly: (endDate: string) => moment(endDate).daysInMonth(),
});

export const PERIOD_ENDING_DATE_FORMATS = ["DD-MM-YYYY HH:mm:ss", "DD-MM-YYYY"];
export const CREATED_DATE_FORMAT = "DD/MM/YYYY hh:mm A";
export const PERIOD_ENDING_DISPLAY_DATE_FORMAT = "DD MMM YYYY";

export const DEFAULT_UNIT_FIELDS = {
  CamCall: "00:00",
  CamWrap: "00:00",
  StartMeal: "00:00",
  StartMeal2: "00:00",
  StartMeal3: "00:00",
  FinishMeal1: "00:00",
  FinishMeal2: "00:00",
  FinishMeal3: "00:00",
  MB1ND: "0",
  MB2ND: "0",
  MB3ND: "0",
  Start: "00:00",
  Finish: "00:00",
  TotalHours: "00:00",
  TimeStamp: 123456,
  Payas: "0",
  customNote: null,
  Travel1: "00:00",
  Note: null,
  Travel2: "00:00",
  TotalMBDed: "00:00",
};
